import { createPinia, setActivePinia } from 'pinia'
import { useFiscalStore } from '@restify/packages/stores/fiscal'
import useFeathers from '~/composables/useFeathers'

export default () => {
  const feathers = useFeathers()
  const pinia = createPinia()
  setActivePinia(pinia)

  // Inject the cloud `pi-fiscal` proxy service into the shared fiscal store.
  // Replaces the legacy `fiscalApiBase` localStorage URL flow.
  useFiscalStore().setPiFiscalService(feathers.service('pi-fiscal'))

  return { provide: { pinia, feathers, api: feathers } }
}
